import { AddressMeeting } from "@complex/AddressMeeting";
import { type Control, useWatch } from "react-hook-form";
import type { IModalActionForm, IModalActionResolver } from "../logics/types";
import { hasAddressDisplayed, hasAddressRequired } from "../logics/utils";

export interface IModalActionFormAddressProps {
  control: Control<IModalActionForm, void, IModalActionResolver>;
}

export const ModalActionFormAddress = ({ control }: IModalActionFormAddressProps) => {
  const [type, contactChannel, status, shouldScheduleAppointmentReminder] = useWatch({
    control,
    name: ["type", "contactChannel", "status", "shouldScheduleAppointmentReminder"],
  });

  if (!hasAddressDisplayed(type, contactChannel, status, shouldScheduleAppointmentReminder)) {
    return null;
  }

  const required = hasAddressRequired(type, contactChannel);

  return <AddressMeeting control={control} name="address" label={`Adresse du rendez-vous${required ? " *" : ""}`} />;
};
